import React, { FC } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

interface ServicosModelo {
  ServicoImagem: string;
  ServicoTitulo: string;
  ServicoDescricao: string;
  ServicoNomeBotao: string;
  ServicoLinkBotao: string;
}

const dadosTexto = {
  Titulo: 'Nossos Serviços',
  Texto: 'Confiança é a base do nosso compromisso com o associado. Nosso propósito é oferecer tranquilidade para quem usa seu veículo, para lazer ou trabalho. Seja carro, moto ou caminhão, nós temos a melhor proteção para garantir sua satisfação quando precisar usar algum benefício.'
};

const servicesData: ServicosModelo[] = [
  {
    ServicoImagem: '/images/servm3-3.jpg',
    ServicoTitulo: 'Assistência 24h',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
  {
    ServicoImagem: '/images/servm3-1.jpg',
    ServicoTitulo: 'Clube de Vantagens',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
  {
    ServicoImagem: '/images/servm2-med.jpg',
    ServicoTitulo: 'Telemedicina',
    ServicoDescricao: 'Confiança é a base do nosso compromisso com o associado.',
    ServicoNomeBotao: "String",
    ServicoLinkBotao: "String"
  },
];

const Servico: FC = () => {
  return (
    <section id="servicos" className="text-center px-6 lg:px-14 bg-theme-primary py-12">
      <h2 className="text-textotitulo text-theme-light-primary font-bold mb-4">{definicoescliente?.Servico?.Titulo || dadosTexto.Titulo}</h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {(definicoescliente.Servico.Servicos.length ? definicoescliente.Servico.Servicos : servicesData)
          .map((Servico, index) => (
          <div key={index} className="flex flex-col items-center bg-theme-light-secondary p-8 rounded-lg shadow-md">
            <img src={Servico.ServicoImagem || servicesData[index]?.ServicoImagem} alt={Servico.ServicoTitulo || servicesData[index]?.ServicoTitulo}  className="rounded-full w-24 h-24 mb-4 object-cover"/>
            <h3 className="text-textotitulo text-theme-secondary font-semibold">{Servico.ServicoTitulo || servicesData[index]?.ServicoTitulo}</h3>
            <p className="text-theme-secondary text-textopadrao mb-4">{Servico.ServicoDescricao || Servico.ServicoDescricao}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Servico;
